import { ArrowStatefulIcon } from '@mm/icons';
import React from 'react';
import { useSelector } from 'react-redux';
import useRouter from 'use-react-router';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import * as routes from '../../../../../../../common/constants/routes';
import { BotBuilderRoutes } from '../../../../../../../routes/bot-builder-routes';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import { Heading } from '@mm/components';
import './ActivationPage.pcss';
import { SMSRouter } from './SMSRouter';

export const SMSActivationPage = () => {
  const {
    history,
    location: { pathname },
  } = useRouter();
  const { id } = useSelector(activeChatbotSelector);

  const onCancel = () => {
    history.push(
      `${BotBuilderRoutes.settingsSms.getLink({
        chatbotId: Number(id),
      })}`,
    );
  };

  const showCrumbs = pathname.includes('area-code-search');

  return (
    <div className="sms-settings">
      <div className="sms-settings__content-header-container">
        {!showCrumbs && (
          <Heading
            size={3}
            text="SMS Settings"
            className="sms-settings__content-heading"
          />
        )}
        {showCrumbs && (
          <>
            <div className="sms-settings__crumbs">
              <Heading
                size={5}
                isBold={false}
                text="SMS Settings"
                className="sms-settings__crumb-heading"
              />
              <ArrowStatefulIcon size={10} style={{ marginRight: 5 }} />
              <Heading
                size={3}
                text="Phone number registration"
                className="sms-settings__crumb-heading"
              />
            </div>
            <PrimaryButton
              className="phone-number-selection__button-cancel"
              color={ButtonColor.secondaryBlue}
              onClick={onCancel}
            >
              Cancel
            </PrimaryButton>
          </>
        )}
      </div>
      <div className="sms-settings__content-container">
        <SMSRouter path={routes.SETTINGS_SMS(id)} chatbotId={id} />
      </div>
    </div>
  );
};
